import {Component, inject, OnInit, signal} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MessageService} from '@lib-services/message.service';
import {IItem, IItemCreate, IItemUpdate} from '@lib-typing/item.interface';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {ItemService} from '@lib-services/items.service';
import {CommonDropdownComponent} from '@lib-ui/common-dropdawn/common-dropdown.component';
import {CategorySelectorService} from '@lib-services/category-selector.service';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {Item} from '@libs-classes/item.class';
import {MatOption, MatSelect} from '@angular/material/select';
import {EnumService} from '@lib-services/enum.service';
import {OrderStatusEnum} from '@libs-enums/status.enum';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {filter, switchMap} from 'rxjs';
import { CloseButtonComponent } from '@lib-ui/close-button/close-button.component';

@Component({
    selector: 'app-item-form',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatFormField,
        MatInput,
        MatButton,
        MatLabel,
        CommonDropdownComponent,
        MatSelect,
        MatOption,
        MatDialogContent,
        LoaderComponent,
        CloseButtonComponent,
        MatDialogTitle,
    ],
    templateUrl: './item-form.component.html',
    styleUrl: './item-form.component.scss'
})
export class ItemFormComponent implements OnInit {
    itemForm: FormGroup;
    item = new Item({} as IItem);
    loading = signal(false);
    public data: { itemId?: number } = inject(MAT_DIALOG_DATA);
    protected readonly StatusEnum = OrderStatusEnum;

    constructor(
        private fb: FormBuilder,
        protected dialogRef: MatDialogRef<ItemFormComponent>,
        protected enumService: EnumService,
        private messageService: MessageService,
        private itemService: ItemService,
        protected categorySelectorService: CategorySelectorService,
    ) {
        this.itemForm = this.fb.group({
            name: ['', Validators.required],
            categoryId: [null, Validators.required],
            description: [''],
        });
    }

    ngOnInit(): void {

        if (this.data.itemId) {
            this.loading.set(true);
            this.itemService.getItem(this.data.itemId).subscribe( {
                next: data => {
                    this.item.data = data;
                    this.itemForm.setValue(this.item.formData());
                },
                error: error => {this.messageService.errorMessage(error.message);}
            }).add(() => this.loading.set(false));
        }
    }

    onSubmit(): void {
        if (!this.itemForm.valid) {
            return;
        }

        this.loading.set(true);
        const request = this.item.data.id
            ? this.itemService.updateItem(this.item.dataForUpdate(this.itemForm.value as IItemUpdate))
            :  this.itemService.createItem(this.item.dataForCreate(this.itemForm.value as IItemCreate));

        request.subscribe({
            next: result => {
                this.messageService.successMessage('Оборудование успешно добавлено');
                this.dialogRef.close(result);},
            error: error => {this.messageService.errorMessage(error.message);}
        }).add(() => this.loading.set(false));
    }

    get categoryControl(): FormControl {
        return this.itemForm.get('categoryId') as FormControl;
    }

    deleteItem(id: number): void {
        if(!this.item.data) {return;}

        this.messageService.confirmMessage({
            title: 'Удаление оборудования',
            text: 'Вы действительно хотите удалить оборудование?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.itemService.deleteItems([id]);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Оборудование успешно удалена');
                this.dialogRef.close(true);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }
}
